import React, { memo } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { DialogHeading } from 'components/dialog-title';
import { useTranslate } from 'hooks/use-translate';
import { GridTaskActivities } from '../grid-activities';
import style from './index.module.scss';

import { ignoreEscapeKeyDown } from 'utils/handlers';

interface Props {
  toDoTaskID: string;
  onClose: () => void;
  onRefresh?: () => void;
}
export const DialogToDoActivities = memo<Props>(({ toDoTaskID, onClose, onRefresh }) => {
  const { t } = useTranslate();
  return (
    <Dialog
      open={true}
      onClose={ignoreEscapeKeyDown(onClose)}
      fullWidth
      maxWidth="lg"
      className={style.dialog}
    >
      <DialogHeading title={t('activities')} onClose={onClose} />
      <DialogContent>
        <GridTaskActivities toDoTaskID={toDoTaskID} onRefresh={onRefresh} />
      </DialogContent>
    </Dialog>
  );
});
